import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { clientsApi } from '@modules/clients/entities/client/api';
import { EmailChannelProviderType } from '@modules/opportunities/presentation/pages/CaseCreation/views/BankSubmission/SubmitApplications/components/DirectToBankSubmissionSlido/const';
import queryClient from '@app/queryClient';

const useSetEmailPreferences = (accountExternalId: string) => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['setEmailPreferences', accountExternalId],
    mutationFn: (preferredEmailChannel: EmailChannelProviderType) =>
      clientsApi.setEmailPreferences(accountExternalId, preferredEmailChannel),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getEmailPreferences'] });
    },
    onError: () => {
      toast('error', { message: 'Error while setting email preference' });
    },
  });

  return {
    mutate,
    error,
    isPending,
    mutateAsync,
  };
};

export default useSetEmailPreferences;
